var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive && _vm._level)?_c('a',{staticClass:"xw-vip",class:`xw-vip-${_vm._level}`,attrs:{"href":"https://wan.xunlei.com/vip-rights","title":"VIP等级","target":"_blank"},on:{"click":function($event){return _vm.$emit('click')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }